import { render, staticRenderFns } from "./VehicleListTable.vue?vue&type=template&id=478b587c&scoped=true&lang=pug"
import script from "./VehicleListTable.vue?vue&type=script&lang=js"
export * from "./VehicleListTable.vue?vue&type=script&lang=js"
import style0 from "./VehicleListTable.vue?vue&type=style&index=0&id=478b587c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b587c",
  null
  
)

export default component.exports